export const getTimeExpire = (timestamp) => {
    return new Date(timestamp * 1000)
}
